<svg class="sz-icon" [attr.width]="pixels()" [attr.height]="pixels()" aria-hidden="true" focusable="false">
  <use [attr.href]="href()" />
</svg>
